import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=d6c8cb8c&"
import script from "./IconBox.vue?vue&type=script&lang=js&"
export * from "./IconBox.vue?vue&type=script&lang=js&"
import style0 from "./IconBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports